<template>
    <div>
        <MyAthletesList
                @player="selectPlayer($event)"
                :disabled="$route.params.playerkey"
                :autorefreshmobile="autorefreshmobile"
        />
        <NewAthlete
                v-if="(myathletes && myathletes.length<5) || permissions && (permissions.includes('director'))"
                @participant="getMyAthletes"
        />
    </div>
</template>

<script>
  //5c6e52cd-9bd9-4c85-9df2-f6cb8c9a1ad1_athleteforlife_2t2kjgfxet7
  //5c6e52cd-9bd9-4c85-9df2-f6cb8c9a1ad1_athleteforlife_2t2kjgfxev1
  import {
    mapState,
    mapActions,
    mapMutations
  } from 'vuex'
  import UploaderCropper from "./UploaderCropper";
  import NewAthlete from "@/views/a4l/NewAthlete";
  import MyAthletesList from "@/views/myathletes/MyAthletesList";

  export default {
    components: {MyAthletesList, NewAthlete, UploaderCropper},
    name: "Index",
    data() {
      return {
        activeathlete: undefined,
        editattribute: undefined,
        editval: undefined,
        autorefreshmobile: false
      }
    },
    computed: {
      ...mapState(['myathletes', 'icons', 'sportcode', 'org', 'isLoggedIn', 'permissions', 'athleteobject']),
      loggedIn() {
        return this.$store.getters['cognito/isLoggedIn'];
      },
    },
    created() {
      this.loadAthleteObjectFromStorage()
    },
    mounted() {
      if (this.$route.query.q && this.$route.query.q === 'loggedin') {
        this.autorefreshmobile = true
      }
    },
    methods: {
      ...mapActions(['post', 'get', 'put', 'getMyAthletes']),
      ...mapMutations(['setActivePlayer', 'loadAthleteObjectFromStorage']),
      async selectPlayer(e) {
        console.log(e)
        if (this.athleteobject[e.partkey]) {
          let p = this.athleteobject[e.partkey]
          this.setActivePlayer(p)
        }
        this.$router.push('/myathletes/profile/' + e.partkey)
      }
    }
  }
</script>

<style scoped>
    .ol {
        border: solid thin green
    }
</style>